import React from 'react'
import menuStatic from '../../config/layouts/menu.json'
import menuParseAndEnrich from '../../modules/menu-parse-and-enrich'
import hasItems from '../../modules/has-items'

const ContextMenu = React.createContext({})

const MenuProvider = ({ children, menuResponse }) => {
  const menuData = hasItems(menuResponse) ? menuResponse : menuStatic
  return <ContextMenu.Provider value={menuParseAndEnrich(menuData)}>{children}</ContextMenu.Provider>
}

export default ContextMenu

export { MenuProvider }
